/* cb-variant-sync-expanse-8.js
 * Expanse 8.0/9.0
 * Allows "preview selecting" sold-out swatches by forcing the underlying radio
 * button state and triggering native change events. Expanse completely handles
 * updating URL, Inventory, Add to Cart state, and Swym widgets naturally.
 */

(function () {
  function getSwatchValueFromClickTarget(target) {
    // Expanse 8/9 swatches are usually labels with for="" pointing to an input
    const label = target.closest("label");
    if (!label) return null;

    const forId = label.getAttribute("for");
    let input = null;

    if (forId) input = document.getElementById(forId);
    if (!input) input = label.querySelector('input[type="radio"]');
    if (!input) return null;

    // We only care about option1/color group if it exists
    const isColor =
      input.getAttribute("data-index") === "option1" ||
      input.name === "options[Option]" ||
      (input.name || "").includes("options[");

    if (!isColor) return null;

    const val =
      (input.getAttribute("data-disabled-value") || "").trim() ||
      (input.getAttribute("data-value") || "").trim() ||
      (input.value || "").trim();

    if (!val) return null;

    // Determine sold-out state from label/input
    const soldOut =
      input.disabled ||
      label.classList.contains("disabled") ||
      label.classList.contains("is-disabled") ||
      label.getAttribute("aria-disabled") === "true" ||
      !!label.querySelector(".element-swatch--disabled") ||
      !!label.querySelector(".element-swatch__item--disabled");

    return { value: val, soldOut, input, label };
  }

  // Handle clicks on swatches (including sold-out)
  document.addEventListener("click", function (e) {
    const info = getSwatchValueFromClickTarget(e.target);
    if (!info) return;

    // If sold out, Expanse blocks selection via CSS/disabled attributes
    if (info.soldOut) {
      e.preventDefault();

      // Ensure the underlying radio button is actually checked overriding the browser's disabled lock
      info.input.checked = true;

      // Dispatch change event to trigger native Expanse theme variant logic!
      // This guarantees Inventory, Swym Notify Me, URLs, and Add-to-cart buttons are correctly natively processed
      info.input.dispatchEvent(new Event('change', { bubbles: true }));

      return;
    }
  }, true);
})();
